import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { billingApi } from "../api/billingApi";
import { isSubscriptionGuardBypass, TOKEN_KEY } from "../utils/jwtUtils";

const DiySubscriptionGuard: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  const isCheckoutSuccess = location.search.includes("checkout=success");

  const [status, setStatus] = useState<"loading" | "active" | "none">(() => {
    if (typeof window !== "undefined" && isCheckoutSuccess) {
      return "active";
    }
    const token = localStorage.getItem(TOKEN_KEY);
    return isSubscriptionGuardBypass(token) ? "active" : "loading";
  });

  useEffect(() => {
    let cancelled = false;

    if (isCheckoutSuccess) {
      if (!cancelled) {
        setStatus("active");
      }
      return () => {
        cancelled = true;
      };
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (isSubscriptionGuardBypass(token)) {
      if (!cancelled) {
        setStatus("active");
      }
      return () => {
        cancelled = true;
      };
    }

    billingApi
      .getSubscription()
      .then((sub) => {
        if (cancelled) {
          return;
        }
        if (sub && (sub.status === "active" || sub.status === "trialing")) {
          setStatus("active");
        } else {
          setStatus("none");
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus("none");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isCheckoutSuccess]);

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-900">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  }

  if (status === "none") {
    return <Navigate to="/diy?checkout=required" replace />;
  }

  return children;
};

export default DiySubscriptionGuard;
